// @core/api/endpoints/document/append_blocks.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AppendBlocksRequest,
  AppendBlocksResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Append blocks
 * Appends one or more blocks to a document at the top level or as children of an existing block. Returns the created blocks with server-assigned IDs and positions.
 */
export async function AppendBlocks(
  document_id: string,
  data: AppendBlocksRequest,
  options?: RequestOptions
): Promise<AppendBlocksResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id/blocks`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  const requestOptions = options;
  return client.post<AppendBlocksResponse>(requestPath, data, requestOptions);
}
